// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-title_root__PZgxd","sizelg":"accordion-title_sizelg__K4unB","sizexl":"accordion-title_sizexl__76c45"};